export class NamedEntity {
  id: string;
  name: string;
  attributes: Record<string, any> = {};

  constructor(id: string, name: string, attributes: Record<string, any> = {}) {
    this.id = id;
    this.name = name;
    this.attributes = attributes;
  }
}
